// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2Ky0x","question":"Question_question__BQ4zQ","description":"Question_description__3OA-N"};